module.exports = __webpack_public_path__ + "img/es1.da7b7fd4.jpg";